export const ROUTE_PATH = '/mallBonuses';
